<template>
  <div>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid p-0 pt-3" v-if="loaded">
      <!-- COURSE DUE -->
      <div class="row">
        <div class="col offset-md-8">
          <div class="col p-3 p-md-0">
            <course-viewer :field="field" v-for="field in section.contentMedia" :key="field.id"></course-viewer>
          </div>
        </div>
      </div>

      <!-- CONTENT -->
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1 p-3 p-md-0">
          <course-viewer :field="field" v-for="field in section.content" :key="field.id"></course-viewer>
        </div>
      </div>


      <!-- LEARNING ACTIVITY -->
      <div>
        <div class="p-lg-5 p-3 text-center text-md-left mt-5 bg-white p-2" style="border-top: 2px dashed #CFD8EE; border-bottom: 2px dashed #CFD8EE;">
          <course-viewer :field="field" v-for="field in section.learning" :key="field.id"></course-viewer>
        </div>
      </div>

      <div class="row">
        <div class="col-6 col-md-4 p-0">
          <button @click="$router.back()" class="btn btn-block btn-teal h-100">
            <font-awesome-icon icon="arrow-circle-left"></font-awesome-icon>
            Back
          </button>
        </div>
        <div class="col-6 col-md-4 offset-md-4 p-0">
          <router-link :to="(nextSection.is_form) ? '/assignment/' + nextSection.form_id : '/training/' + nextSection.id" class="btn btn-block btn-teal" v-if="nextSection">
            <font-awesome-icon icon="arrow-circle-right"></font-awesome-icon>
            {{ nextSection.name | truncate(25) }}
          </router-link>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import CourseViewer from '../../components/CourseViewer';

export default {
  name: 'Training',
  components: {CourseViewer},
  data () {
    return {
      section: {
        content: [],
        learning: []
      },
      loading: true,
      loaded: false
    };
  },
  methods: {
    loadSection () {
      this.axios.get('sections/' + this.id, {params: {includes: 'course,module,components'}}).then((rsp) => {
        this.section = rsp.data.data;
        this.loaded = true;
      }).catch(err => this.$errorOut(err));
    }
  },
  computed: {
    currentCourse () {
      return [...this.$store.state.studentCourses].find(x => x.course_id === parseInt(this.section.course_id, 10)) || false;
    },
    currentModule () {
      return this.currentCourse ? this.currentCourse.user_modules.find(x => x.module.id === parseInt(this.section.module_id, 10)) : {user_sections: []};
    },
    currentIndex () {
      return this.currentModule.user_sections.findIndex(section => {
        return section.section_id === this.section.id;
      });
    },
    nextSection () {
      if (!this.currentModule) {
        return false;
      }
      // Next Section found
      if (this.currentIndex < this.currentModule.user_sections.length - 1) {
        return this.currentModule.user_sections[this.currentIndex + 1].section;
      }
      // Calculate Course Due Date from user_course

      //const courseEnabled = dateFns(course.enabled_at);
      //this.courseDue = courseEnabled.add(course.duration, 'weeks').format('dddd, MMMM Do YYYY');

      return false;

    }
  },
  mounted () {
    this.loadSection();
  },
  metaInfo: {
    title: 'Training'
  },
  props: ['id']
};
</script>
